export default "__VITE_ASSET__Cb$QqeTa__"